import { render, staticRenderFns } from "./SfBar.vue?vue&type=template&id=3978c74c&"
import script from "./SfBar.vue?vue&type=script&lang=js&"
export * from "./SfBar.vue?vue&type=script&lang=js&"
import style0 from "./SfBar.vue?vue&type=style&index=0&id=3978c74c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports